// extracted by mini-css-extract-plugin
export default {"type-center":"main_type-center--uJY8U","type-sublabel":"main_type-sublabel--u4yrV","unit":"main_unit--PIj9C"};